import axios from "axios";

let API_URL = process.env.REACT_APP_API_URL;
API_URL = API_URL + "purchase-return";

class PurchaseReturn {
  create = async (val: any) => {
    await axios({
      method: "post",
      url: `${API_URL}`,
      data: val,
    }).catch((e) => {
     throw e;
    });
  };
  edit = async (val: any, code: any) => {
    await axios({
      method: "put",
      url: `${API_URL}/${code}`,
      data: val,
    }).catch((e) => {
     throw e;
    });
  };
  get = async (code: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}/${code}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.purchaseReturn;
  };
  getAll = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}-get-all`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.purchasesReturn;
  };

  reversal = async (code: any) => {
    const response = await axios({
      method: "put",
      url: `${API_URL}-reversal`,
      data: code
    }).catch((e) => {
      throw e.message;
    });
    return response.data;
  };
  // search = async (keyword: any) => {
  //   const response = await axios({
  //     method: "get",
  //     url: `${API_URL}SalesReturn-search/${keyword}`,
  //   }).catch((e) => {
  //     throw e.message;
  //   });
  //   return response.data.SalesReturn;
  // };
}
export default new PurchaseReturn();
